export const esTranslatedStrings = {
    "category_task_model": "Modelo de tarea",
    "category_warm_up": "Preparación del tema / Calentamiento",
    "category_developing": "Desarrollo de conocimientos / habilidades",
    "category_vocabulary": "Vocabulario y expresiones",
    "category_custom": "Personalizado",
    "category_task_repetition": "Repetición de tarea / Tarea de seguimiento",
    "category_explicit_explanation": "Explicación explícita",
    "category_reflection": "Reflexión",
    "category_written_oral": "De escrito a oral / de oral a escrito",
    "activity_listening": "Comprensión oral",
    "activity_watching": "Visionado",
    "activity_reading": "Lectura",
    "activity_speaking": "Expresión oral",
    "activity_writing": "Escritura",
    "activity_interaction": "Interacción",
    "activity_exercise": "Ejercicio",
    "activity_game": "Juego",
    "Activity types": "Tipos de actividad",
    "Select at least one activity type": "Selecciona al menos un tipo de actividad",
    "Short text": "Texto breve",
    "Description (optional)": "Descripción (opcional)",
    "Edit interaction design": "Editar el diseño de interacción",
    "Edit Interaction": "Editar la interacción",
    "The exercise designer will be available soon.": "El diseñador de ejercicios estará disponible pronto.",
    "Edit Pre-Task": "Editar la Pre-tarea",
    "Edit Post-Task": "Editar la Post-tarea",
    "Add text": "Añadir texto",
    "Add image": "Añadir imagen",
    "Add audio": "Añadir audio",
    "Add video": "Añadir vídeo",
    "Title": "Título",
    "Drag to reorder": "Arrastra para reordenar",
    "Are you sure you want to delete this material?": "¿Seguro que quieres eliminar este material?",
    "Please enter a title.": "Introduce un título.",
    "It will be active again shortly.":"Volverá a estar activo en breve.",
    "Thank you for your patience.":"Gracias por tu paciencia.",
    "You don't have an account?":"¿No tienes una cuenta?",
    "Register as a new user":"Regístrate como nuevo usuario",
    "Register":"Regístrate",
    "University":"Universidad",
    "Secondary school":"Escuela secundaria",
    "Primary school":"Escuela primaria",
    "Private tutoring":"Clases particulares",
    "Online private tutoring":"Clases particulares en línea/ Clases particulares online",
    "Language school":"Escuela de idiomas",
    "I am not teaching yet":"Todavía no estoy enseñando/ Aún no estoy enseñando",
    "Face to Face":"Presencial ",
    "Fully online":"Completamente en línea/ Completamente online",
    "Hybrid/Blended":"Híbrido/ Semipresencial",
    "Task Based Language Teaching":"Enseñanza de Idiomas Basada en Tareas (TBLT)",
    "Content and Language Integrate Learning":"Aprendizaje Integrado de Contenidos y Lengua (CLIL)",
    "Project-based Learning":"Aprendizaje basado en proyectos",
    "Traditional Teaching":"Enseñanza tradicional",
    "Language for Specific Purposes":"Idioma para fines específicos",
    "Language for Academic Purposes":"Idioma para fines académicos",
    "English as a Medium of Instruction":"Inglés como medio de enseñanza/ Inglés como medio de instrucción",
    "Afghanistan":"Afganistán",
    "Albania":"Albania",
    "Algeria":"Algeria",
    "American Samoa":"Samoa americana",
    "Andorra":"Andorra",
    "Angola":"Angola",
    "Anguilla":"Anguila",
    "Antarctica":"Antártida",
    "Antigua and Barbuda":"Antigua y Barbuda",
    "Argentina":"Argentina",
    "Armenia":"Armenia",
    "Aruba":"Aruba",
    "Australia":"Australia",
    "Austria":"Austria",
    "Azerbaijan":"Azerbaiyán",
    "Bahamas (the)":"Bahamas (las)",
    "Bahrain":"Baréin",
    "Bangladesh":"Bangladesh/Banglades",
    "Barbados":"Barbados",
    "Belarus":"Bielorrusia",
    "Belgium":"Bélgica",
    "Belize":"Belice",
    "Benin":"Benín",
    "Bermuda":"Bermudas",
    "Bhutan":"Bután",
    "Bolivia (Plurinational State of)":"Bolivia (Estado plurinacional de)",
    "Bonaire, Sint Eustatius and Saba":"Bonaire, San Eustaqui y Saba",
    "Bosnia and Herzegovina":"Bosnia y Herzegovina",
    "Botswana":"Botsuana",
    "Bouvet Island":"Isla Bouvet",
    "Brazil":"Brasil",
    "British Indian Ocean Territory (the)":"Territorio británico del océano índico",
    "Brunei Darussalam":"Brunéi",
    "Bulgaria":"Bulgaria",
    "Burkina Faso":"Burkina Faso",
    "Burundi":"Burundi",
    "Cabo Verde":"Cabo Verde",
    "Cambodia":"Camboya",
    "Cameroon":"Camerún",
    "Canada":"Canadá",
    "Cayman Islands (the)":"Islas Caimán",
    "Central African Republic (the)":"República Centroafricana",
    "Chad":"Chad",
    "Chile":"Chile",
    "China":"China",
    "Christmas Island":"Isla de Navidad",
    "Cocos (Keeling) Islands (the)":"Islas Cocos (Islas Keeling)",
    "Colombia":"Colombia",
    "Comoros (the)":"Comoras",
    "Congo (the Democratic Republic of the)":"República Democrática del Congo/ Congo (República Democrática del)",
    "Congo (the)":"Congo (El)",
    "Cook Islands (the)":"Islas Cook",
    "Costa Rica":"Costa Rica",
    "Croatia":"Croacia",
    "Cuba":"Cuba",
    "Curaçao":"Curazao",
    "Cyprus":"Chipre",
    "Czechia":"Chequia",
    "Côte d'Ivoire":"Costa de Marfil",
    "Denmark":"Dinamarca",
    "Djibouti":"Yibuti",
    "Dominica":"Dominica",
    "Dominican Republic (the)":"República Dominicana",
    "Ecuador":"Ecuador",
    "Egypt":"Egipto",
    "El Salvador":"El Salvador",
    "Equatorial Guinea":"Guinea Ecuatorial",
    "Eritrea":"Eritrea",
    "Estonia":"Estonia",
    "Eswatini":"Esuatini",
    "Ethiopia":"Etiopía",
    "Falkland Islands (the) [Malvinas]":"Islas Malvinas (Falkland Islands)",
    "Faroe Islands (the)":"Islas Feroe",
    "Fiji":"Fiyi",
    "Finland":"Finlandia",
    "France":"Francia",
    "French Guiana":"Guayana Francesa",
    "French Polynesia":"Polinesia Francesa",
    "French Southern Territories (the)":"Territorios Australes Franceses",
    "Gabon":"Gabón",
    "Gambia (the)":"Gambia",
    "Georgia":"Georgia",
    "Germany":"Alemania",
    "Ghana":"Ghana",
    "Gibraltar":"Gibraltar",
    "Greece":"Grecia",
    "Greenland":"Groenlandia",
    "Grenada":"Granada",
    "Guadeloupe":"Guadalupe",
    "Guam":"Guam",
    "Guatemala":"Guatemala",
    "Guernsey":"Guernsey",
    "Guinea":"Guinea",
    "Guinea-Bissau":"Guinea-Bissau",
    "Guyana":"Guyana",
    "Haiti":"Haití",
    "Heard Island and McDonald Islands":"Islas Heard y Mc Donald",
    "Holy See (the)":"Ciudad del Vaticano",
    "Honduras":"Honduras",
    "Hong Kong":"Hong Kong",
    "Hungary":"Hungría",
    "Iceland":"Islandia",
    "India":"India",
    "Indonesia":"Indonesia",
    "Iran (Islamic Republic of)":"Irán (República Islámica de)",
    "Iraq":"Irak",
    "Ireland":"Irlanda",
    "Isle of Man":"Isla de Man",
    "Israel":"Israel",
    "Italy":"Italia",
    "Jamaica":"Jamaica",
    "Japan":"Japón",
    "Jersey":"Jersey",
    "Jordan":"Jordania",
    "Kazakhstan":"Kazajistán",
    "Kenya":"Kenia",
    "Kiribati":"Kiribati",
    "Korea (the Democratic People's Republic of)":"Corea (República Popular Democrática de)",
    "Korea (the Republic of)":"Corea (República de)",
    "Kuwait":"Kuwait",
    "Kyrgyzstan":"Kirguistán",
    "Lao People's Democratic Republic (the)":"Laos (República Popular Democrática de)",
    "Latvia":"Letonia",
    "Lebanon":"Líbano",
    "Lesotho":"Lesoto",
    "Liberia":"Liberia",
    "Libya":"Libia",
    "Liechtenstein":"Liechtenstein",
    "Lithuania":"Lituania",
    "Luxembourg":"Luxemburgo",
    "Macao":"Macao",
    "Madagascar":"Madagascar",
    "Malawi":"Malaui",
    "Malaysia":"Malasia",
    "Maldives":"Maldivas",
    "Mali":"Mali",
    "Malta":"Malta",
    "Marshall Islands (the)":"Islas Marshall",
    "Martinique":"Martinica",
    "Mauritania":"Mauritania",
    "Mauritius":"Mauricio",
    "Mayotte":"Mayotte",
    "Mexico":"México",
    "Micronesia (Federated States of)":"Micronesia (Estados Federados de)",
    "Moldova (the Republic of)":"Moldavia (República de)",
    "Monaco":"Mónaco",
    "Mongolia":"Mongolia",
    "Montenegro":"Montenegro",
    "Montserrat":"Montserrat",
    "Morocco":"Marruecos",
    "Mozambique":"Mozambique",
    "Myanmar":"Myanmar",
    "Namibia":"Namibia",
    "Nauru":"Nauru",
    "Nepal":"Nepal",
    "Netherlands (the)":"Países Bajos",
    "New Caledonia":"Nueva Caledonia",
    "New Zealand":"Nueva Zelanda",
    "Nicaragua":"Nicaragua",
    "Niger (the)":"Níger",
    "Nigeria":"Nigeria",
    "Niue":"Niue ",
    "Norfolk Island":"Isla de Norfolk",
    "Northern Mariana Islands (the)":"Islas Marianas del Norte",
    "Norway":"Noruega",
    "Oman":"Omán ",
    "Pakistan":"Pakistán ",
    "Palau":"Palaos",
    "Palestine, State of":"Estado de Palestina",
    "Panama":"Panamá",
    "Papua New Guinea":"Papúa Nueva Guinea",
    "Paraguay":"Paraguay",
    "Peru":"Perú",
    "Philippines (the)":"Filipinas",
    "Pitcairn":"Islas Pitcairn ",
    "Poland":"Polonia",
    "Portugal":"Portugal",
    "Puerto Rico":"Puerto Rico",
    "Qatar":"Qatar",
    "Republic of North Macedonia":"República de Macedonia del Norte",
    "Romania":"Rumanía",
    "Russian Federation (the)":"Federación de Rusia",
    "Rwanda":"Ruanda",
    "Réunion":"Reunión",
    "Saint Barthélemy":"San Bartolomé",
    "Saint Helena, Ascension and Tristan da Cunha":"Santa Helena, Ascensión y Tristán de Acuña",
    "Saint Kitts and Nevis":"San Cristóbal y Nieves",
    "Saint Lucia":"Santa Lucía",
    "Saint Martin (French part)":"San Martín (parte francesa)",
    "Saint Pierre and Miquelon":"San Pedro y Miquelón",
    "Saint Vincent and the Grenadines":"San Vicente y las Granadinas",
    "Samoa":"Samoa",
    "San Marino":"San Marino",
    "Sao Tome and Principe":"Santo Tomé y Príncipe",
    "Saudi Arabia":"Arabia Saudita",
    "Senegal":"Senegal",
    "Serbia":"Serbia",
    "Seychelles":"Seychelles",
    "Sierra Leone":"Sierra Leona",
    "Singapore":"Singapur",
    "Sint Maarten (Dutch part)":"Sint Maarten (parte neerlandesa)",
    "Slovakia":"Eslovaquia",
    "Sloveni":"Eslovenia",
    "Solomon Islands":"Islas Salomón",
    "Somalia":"Somalia",
    "South Africa":"Sudáfrica",
    "South Georgia and the South Sandwich Islands":"Georgia del Sur y las Islas Sandwich del Sur",
    "South Sudan":"Sudán del Sur",
    "Spain":"España",
    "Sri Lanka":"Sri Lanka",
    "Sudan (the)":"Sudán",
    "Suriname":"Surinam",
    "Svalbard and Jan Mayen":"Svalbard y Jan Mayen",
    "Sweden":"Suecia",
    "Switzerland":"Suiza",
    "Syrian Arab Republic":"República Árabe Siria",
    "Taiwan":"Taiwán",
    "Tajikistan":"Tayikistán",
    "Tanzania, United Republic of":"Tanzania, República Unida de",
    "Thailand":"Tailandia",
    "Timor-Leste":"Timor-Leste",
    "Togo":"Togo",
    "Tokelau":"Tokelau",
    "Tonga":"Tonga",
    "Trinidad and Tobago":"Trinidad y Tobago",
    "Tunisia":"Túnez",
    "Turkey":"Turquía",
    "Turkmenistan":"Turkmenistán",
    "Turks and Caicos Islands (the)":"Islas Turcas y Caicos (las)",
    "Tuvalu":"Tuvalu",
    "Uganda":"Uganda",
    "Ukraine":"Ucrania",
    "United Arab Emirates (the)":"Emiratos Árabes Unidos (los)",
    "United Kingdom of Great Britain and Northern Ireland (the)":"Reino Unido de Gran Bretaña e Irlanda del Norte",
    "United States Minor Outlying Islands (the)":"Islas menores alejadas de los Estados Unidos de América",
    "United States of America (the)":"Estados Unidos de América",
    "Uruguay":"Uruguay",
    "Uzbekistan":"Uzbekistán",
    "Vanuatu":"Vanuatu",
    "Venezuela (Bolivarian Republic of)":"Venezuela (República Bolivariana de)",
    "Viet Nam":"Vietnam",
    "Virgin Islands (British)":"Islas Vírgenes Británicas",
    "Virgin Islands (U.S.)":"Islas Vírgenes de los Estados Unidos",
    "Wallis and Futuna":"Wallis y Futuna",
    "Western Sahara":"Sahara Occidental",
    "Yemen":"Yemen",
    "Zambia":"Zambia",
    "Zimbabwe":"Zimbabue",
    "Åland Islands":"Islas Åland",
    "No organization selected.":"No se ha seleccionado ninguna organización.",
    "Users groups":"Grupos de usuarios",
    "New group":"Nuevo grupo",
    "Id":"Id",
    "Name":"Nombre",
    "Users":"Usuarios",
    "Actions":"Acciones",
    "1 user":"Un usuario",
    "users":"usuarios",
    "No users assigned":"No se han asignado usuarios",
    "Edit group":"Editar grupo",
    "Delete group":"Eliminar grupo",
    "Enter a name":"Introducir un nombre",
    "Description":"Descripción",
    "Save":"Guardar",
    "You are about to delete organization content <strong>{{name}}</strong>. 'This action cannot be undone. Are you sure you want to proceed?":"Estás a punto de eliminar el contenido de la organización <strong>{{name}}</strong>. Esta acción no se puede deshacer. ¿Estás seguro de que desea continuar?",
    "Yes":"Sí",
    "No":"No",
    "Add new group":"Agregar nuevo grupo",
    "Conditions of Use":"Condiciones de uso",
    "Introduction":"Introducción",
    "The taskGen Project is a three-year research initiative supported by grant PID2020-119009RB-I00 from the Spanish Ministry of Science and Innovation (MCIN) and the National Research Agency (AEI) [Reference: 10.13039/501100011033]. At the University of Barcelona, we have developed the taskGen web-based tool for the automated design of second/foreign language communicative tasks. Participants engaging in the pilot evaluation through the taskGen platform are required to read and agree to the terms outlined below.":"El proyecto taskGen es una iniciativa de investigación de tres años de duración financiada por la subvención PID2020-119009RB-I00 del Ministerio de Ciencia e Innovación (MCIN) y la Agencia Estatal de Investigación (AEI) [Referencia: 10.13039/501100011033]. En la Universidad de Barcelona hemos desarrollado la herramienta web taskGen para el diseño automatizado de tareas comunicativas en segundas lenguas y lenguas extranjeras. Los participantes en la evaluación piloto a través de la plataforma taskGen deberán leer y aceptar los términos que se describen a continuación.",
    "Consent":"Consentimiento",
    "Participants engaging in this pilot evaluation of the taskGen tool implicitly agree to these terms upon logging into the platform.":"Los participantes de esta evaluación piloto de la herramienta taskGen aceptan implícitamente estos términos al iniciar sesión en la plataforma.",
    "Aim of this research project":"Objetivo de este proyecto de investigación",
    "The aim is to develop a web-based tool that will assist teachers in the design of second and foreign language tasks. The goal is for the tool to help teacher create, clone, share, download/upload onto teaching platforms, and to analyze texts for the automatic detection of linguistic features. Additionally, the tool can be used for training as it contains aids with information about task design.":"El objetivo es desarrollar una herramienta web que ayude a los profesores a diseñar tareas para la enseñanza de segunda lengua y lengua extranjera. La herramiente tiene como finalidad ayudar a los profesares a crear, clonar, compartir, descargar/cargar en plataformas docentes y analizar textos para la detección automática de características lingüísticas. Además, puede utilizarse para formación, ya que contiene recursos con información sobre el diseño de tareas.",
    "Kind participation":"Participación cordial",
    "taskGen users can design, organize, store, and share tasks with other users within the taskGen system. Participation may be stopped at any point. Participants can delete their accounts and leave the system.":"Los usuarios de taskGen podrán diseñar, organizar, almacenar y compartir tareas con otros usuarios dentro del sistema taskGen. La participación podrá interrumpirse en cualquier momento. Los participantes pueden eliminar sus cuentas y abandonar el sistema.",
    "Types of data to be processed":"Tipos de datos que deben tratarse",
    "During the implementation of the pilot, the tool will process (retrieve, store, produce, relate, analyze and use automatically):":"Durante la ejecución del piloto, la herramienta procesará (recuperará, almacenará, producirá, relacionará, analizará y utilizará automáticamente):",
    "From your profile data: educational context, teaching modality, teaching approach, country, years of experience. No information related to your identity will be processed, analysed or shared.":"De los datos de tu perfil: contexto educativo, modalidad de enseñanza, enfoque pedagógico, país, años de experiencia. No se procesará, analizará ni compartirá ninguna información relacionada con su identidad.",
    "System use data: timestamps of platform interaction, mouse-click tracking, text length, choice of pre-task and post-task types, choice of text editing and analysis tools, design options, and use of aids.":"Datos de uso del sistema: marcas de tiempo de interacción con la plataforma, seguimiento de los clics del ratón, longitud del texto, elección de tipos de tareas previas y posteriores, elección de herramientas de edición y análisis de texto, opciones de diseño y uso de ayudas.",
    "Database Security":"Seguridad de la base de datos",
    "Collected data will be securely stored, with access limited to authorized personnel only. Stringent security measures will be employed to protect confidentiality.":"Los datos recopilados se almacenarán de forma segura, con acceso limitado exclusivamente al personal autorizado. Se aplicarán estrictas medidas de seguridad para proteger la confidencialidad.",
    "Data retrieval and treatment":"Recuperación y tratamiento de datos",
    "Standard and secure data analytics tools will be used to retrieve and analyze the collected data exclusively for research purposes.":"Se emplearán herramientas de análisis de datos estándar y seguras para recuperar y analizar los datos recopilados exclusivamente con fines de investigación.",
    "Objectives and legal basis for the processing and treatment of data":"Objetivos y base jurídica del procesamiento y tratamiento de datos",
    "The processing and treatment of the data follows the principles of the data protection law (GDPR) 2016-679 of the European Union as well as the Catalan Agency of Data Protection.":"El tratamiento y procesamiento de los datos se realiza conforme a los principios del Reglamento General de Protección de Datos (RGPD) 2016/679 de la Unión Europea, así como a los establecidos por la Autoridad Catalana de Protección de Datos.",
    "Data will be stored until four years after the end of the project. The treatment of personal data is carried out at/by the General Secretary of Universitat de Barcelona, Gran Via de les Corts Catalanes, 585, 08007 Barcelona. The email address is secretaria.general@ub.edu. You can revoke your consent at any point by contacting the email address above.":"Los datos se conservarán hasta cuatro años después de la finalización del proyecto. El tratamiento de los datos personales se realiza por la Secretaría General de la Universitat de Barcelona, Gran Via de les Corts Catalanes, 585, 08007 Barcelona. La dirección de correo electrónico es secretaria.general@ub.edu. Puede revocar su consentimiento en cualquier momento poniéndose en contacto con la dirección de correo electrónico arriba indicada.",
    "Research Purposes and confidentiality":"Propósitos de la investigación y confidencialidad",
    "The collected data will be used solely for research purposes, enhancing understanding, improving user experience, and informing project development. The results of the project will appear in academic publications and organizations (e.g. Ministry of Education, statistical services, etc.) or in the media with no reference to any data related to participants’ personal information, hence ensuring security, privacy and anonymity. No commercial utilization or third-party sharing will occur.":"Los datos recopilados se utilizarán únicamente con fines de investigación, para mejorar la comprensión, optimizar la experiencia del usuario e informar sobre el desarrollo del proyecto. Los resultados del proyecto podrán publicarse en medios académicos y organizaciones (por ejemplo, el Ministerio de Educación, servicios estadísticos, etc.) o en los medios de comunicación, sin hacer referencia a ningún dato relacionado con la información personal de los participantes, garantizando así la seguridad, la privacidad y el anonimato. No se hará ningún uso comercial ni se compartirán con terceros.",
    "Ethical Compliance":"Cumplimiento ético",
    "The data collection process strictly adheres to ethical standards as set by the University of Barcelona, ensuring responsible handling of information throughout collection, storage, and analysis.":"El proceso de recopilación de datos se ajusta estrictamente a las normas éticas establecidas por la Universidad de Barcelona, garantizando un manejo responsable de la información durante su recopilación, almacenamiento y análisis.",
    "Modification of Terms":"Modificación de los términos",
    "Terms may be modified during the project, and participants will be notified of any changes.":"Los términos pueden modificarse durante el proyecto, y se notificará a los participantes cualquier cambio.",
    "By utilizing the platform, participants acknowledge their understanding and agreement with these terms. Failure to comply may result in access termination.":"Al utilizar la plataforma, los participantes reconocen que comprenden y aceptan estos términos. El incumplimiento de los mismos puede dar lugar a la cancelación del acceso.",
    "If you consider that your rights have not been adequately addressed, you can notify the UB Data Protection Delegate: protecciodedades@ub.edu or Travessera de les Corts, 131-159, Pabellón Rosa, 08028 Barcelona.":"Si consideras que tus derechos no han sido atendidos adecuadamente, puedes comunicarte con el Delegado de Protección de Datos de la UB: protecciodedades@ub.edu o en Travessera de les Corts, 131-159, Pabellón Rosa, 08028 Barcelona.",
    "Likewise, you have the right to file a claim with the Catalan Data Protection Authority.":"Asimismo, tienes derecho a presentar una reclamación ante la Autoridad Catalana de Protección de Datos.",
    "If you have any questions, you can contact the taskGen team at<br />taskgenproject@gmail.com":"Si tienes alguna pregunta, puedes ponerte en contacto con el equipo de taskGen en<br />taskgenproject@gmail.com",
    "By accepting these terms and conditions, I hereby certify that I have permission to use and release the materials included in my task designs. I am responsible for the materials that I will be sharing with other users within taskGen.":"Al aceptar estos términos y condiciones, certifico que tengo permiso para utilizar y divulgar los materiales incluidos en mis diseños de tareas. Soy responsable de los materiales que compartiré con otros usuarios dentro de taskGen.",
    "The taskGen team<br />University of Barcelona":"el equipo taskGen<br />Universidad de Barcelona",
    "Data treatment":"Tratamiento de datos",
    "Update profile":"Actualizar perfil",
    "Profile":"Perfil",
    "Logout your taskGen session":"Cierra la sesión de taskGen",
    "Logout":"Cerrar sesión",
    "Check your inbox and follow the instructions to finish your registration.":"Revisa tu bandeja de entrada y sigue las instrucciones para completar la inscripción.",
    "There was a problem with the registration. It is possible that a user with the same Email is already registered. Please try again later or write to us at info@taskgen.eu.":"Ha habido un problema con el registro. Es posible que ya exista un usuario registrado con el mismo correo electrónico. Por favor, inténtalo de nuevo más tarde o escríbenos a info@taskgen.eu.",
    "Write your mail address and we\'ll send you an email with instructions to finish your registration.":"Escribe tu dirección de correo electrónico y te enviaremos un mensaje con instrucciones para finalizar la inscripción.",
    "Email Address":"Dirección de correo electrónico",
    "By clicking this box, I state that I have read and understood the":"Al hacer clic en esta casilla, declaro que he leído y comprendido los términos y condiciones generales.",
    "terms and conditions":"términos y condiciones generales",
    "Loading...":"Cargando…",
    "A new password has been sent to your inbox. You can change your password in your profile once you log in.":"Se ha enviado una nueva contraseña a tu bandeja de entrada. Podrás cambiarla en tu perfil una vez que inicies sesión.",
    "There was a problem resetting your password. Please try again later or write to us at info@taskgen.eu.":"Se ha producido un problema al restablecer la contraseña. Inténtalo de nuevo más tarde o escríbenos a info@taskgen.eu.",
    "User or password are not vali":"El usuario o la contraseña no son válidos.",
    "Reset your password":"Restablecer contraseña",
    "You don't remember your password?":"¿Has olvidado tu contraseña?",
    "Reset it":"Reiniciar",
    "Login":"Inicio de sesión",
    "We would like to kindly ask you complete you user profile. You will do this only once and you can modify your profile at any point.":"Te rogamos que completes tu perfil de usuario. Solo deberás hacerlo una vez y podrás modificarlo en cualquier momento.",
    "Please, tell us where do you usually teach.":"Por favor, dínos dónde sueles dar clases.",
    "Please, tell us how do you typically teach.":"Por favor, indícanos cómo sueles enseñar.",
    "Please, tell us your general teaching framework.":"Por favor, indícanos cuál es tu enfoque general de enseñanza.",
    "Please, select your country.":"Por favor, selecciona tu país.",
    "Select your country...":"Selecciona tu país...",
    "Please complete your profile. Missing fields:":"Por favor, completa tu perfil. Campos pendientes:",
    "name":"nombre",
    "privacy policy":"política de privacidad",
    "teaching location":"lugar de enseñanza",
    "teaching model":"modelo de enseñanza",
    "teaching framework":"marco de enseñanza",
    "country":"país",
    "region":"región",
    "teaching years":"años de experiencia docente",
    "First name(s)":"Nombre(s)",
    "Family name(s)":"Apellido(s)",
    "Other...":"Otros...",
    "Special Needs":"Necesidades especiales",
    "Have you ever trained using TBLT?":"¿Has recibido formación alguna vez en el enfoque de Aprendizaje Basado en Tareas (TBLT)?",
    "Region or State":"Región o Estado",
    "How many years of teaching experience do you have?":"¿Cuántos años de experiencia como docente tienes?",
    "Tell us for how long you have been teaching in TLBT":"Indícanos cuánto tiempo llevas enseñando con el enfoque de Aprendizaje Basado en Tareas (TBLT)",
    "Edit profile":"Editar perfil",
    "Close window/tab":"Cerrar ventana/pestaña",
    "Shared with students":"Compartido con los estudiantes",
    "Shared with teachers":"Compartido con los profesores",
    "Title":"Título",
    "Authorship":"Autoría",
    "Student's proficiency level":"Nivel de competencia lingüística del alumno",
    "Aims":"Objetivos",
    "Pre-Task":"Pre-tarea",
    "There are no pre-tasks defined":"No hay pre-tareas definidas",
    "Main Tasks":"Tareas principales",
    "There are no tasks":"No hay tareas",
    "Post-Task":"Post-tarea",
    "There are no post-tasks":"No hay post-tareas",
    "Close":"Cerrar",
    "Aim and instructions":"Objetivo e instrucciones",
    "Last updated":"Última actualización",
    "Shared by user":"Compartido por el usuario",
    "Shared by group":"Compartido por el grupo",
    "Duplicate":"Duplicar",
    "Sharing link copied to your clipboard.":"Enlace compartido copiado en el portapapeles.",
    "Edit":"Editar",
    "Share":"Compartir",
    "Share link":"Compartir enlace",
    "Move Up":"Desplazar hacia arriba",
    "Move Down":"Desplazar hacia abajo",
    "Delete":"Eliminar",
    "Share task":"Compartir tarea",
    "Share with users":"Compartir con los usuarios",
    "Shared with someone at":"Compartido con alguien en",
    "Search users...":"Buscar usuarios...",
    "Select the users with whom you want to <strong>share the task</strong>:":"Selecciona los usuarios con los que desea <strong>compartir la tarea</strong>:",
    "Task is shared with the following users:":"La tarea se ha compartido con los siguientes usuarios:",
    "Share with groups":"Compartir con grupos",
    "Select the groups you want to <strong>share the task</strong>:":"Selecciona los grupos con los que desea <strong>compartir la tarea</strong>:",
    "Task is shared with the following groups:":"La tarea se ha compartido con los siguientes grupos:",
    "Cancel":"Cancelar",
    "Add formatting rule":"Añadir regla de formato",
    "Remove":"Eliminar",
    "Feminine":"Femenino",
    "Masculine":"Masculino",
    "Common":"Común",
    "Invariable":"Invariable",
    "Articles":"Artículos",
    "Demonstrative":"Demostrativo",
    "Possessive":"Posesivo",
    "Indefinite":"Indefinido",
    "Interrogative":"Interrogativo",
    "Relative":"Relativo",
    "Numeral":"Numeral",
    "Exclamatory":"Exclamativo",
    "Personal Pronouns":"Pronombres personales",
    "Wh-determiner":"Determinante interrogativo",
    "Subordinating Conjunctions":"Conjunciones subordinantes",
    "Neuter":"Neutro",
    "Animate":"Animado",
    "Inanimate":"Inanimado",
    "Singular":"Singular",
    "Plural":"Plural",
    "Nominative":"Nominativo",
    "Genitive":"Genitivo",
    "Accusative":"Acusativo",
    "Dative":"Dativo",
    "Instrumental":"Instrumental",
    "Locative":"Locativo",
    "Cardinal":"Cardinal",
    "Positive":"Positivo",
    "Short form":"Forma corta",
    "Imperfective":"Imperfectivo",
    "Perfective":"Perfectivo",
    "Indicative":"Indicativo",
    "Conditional":"Condicional",
    "Finite":"Finito",
    "Infinitive":"Infinitivo",
    "Converb":"Converbo",
    "Participle":"Participio",
    "Middle":"Medio",
    "1st person":"1ª persona",
    "2nd person":"2ª persona",
    "3rd person":"3ª persona",
    "Proper nouns":"Nombres propios",
    "All proper nouns":"Todos los nombres propios",
    "Numerals":"Numerales",
    "All numerals":"Todos los numerales",
    "Particles":"Partículas",
    "Aspect":"Aspecto",
    "Mood":"Modo",
    "VerbForm":"Forma verbal",
    "Voice":"Voz",
    "Animacy":"Animacidad",
    "Case":"Caso",
    "Number":"Número",
    "Gender":"Género",
    "Degree":"Grado",
    "Person":"Persona",
    "Form":"Forma",
    "Tense (morphological)":"Tiempo (morfológico)",
    "Interrogative/Relative":"Interrogativo/Relativo",
    "Total":"Total",
    "Personal":"Personal",
    "Past":"Pasado",
    "Present":"Presente",
    "Future":"Futuro",
    "My design":"Mi diseño",
    "Teacher version":"Versión para docentes",
    "Preview":"Vista previa",
    "Download SCORM":"Descargar SCORM",
    "Download HTML":"Descargar HTML",
    "Student version":"Versión para estudiantes",
    "Sessions":"Sesiones",
    "Session name":"Nombre de la sesión",
    "Update":"Actualizar/actualización",
    "Add session":"Añadir sesión",
    "Type":"Tipo",
    "Clone pre-task":"Clonar pre-tarea ",
    "Edit pre-task":"Editar pre-tarea ",
    "Delete pre-task":"Eliminar pre-tarea ",
    "Are you sure you want to delete the pre-task <strong>":"¿Estás seguro de que desea eliminar la pre-tarea <strong>",
    "</strong>? This action cannot be undone.":"</strong>? Esta acción no se puede deshacer.",
    "Are you sure you want to delete the post-task <strong>":"¿Estás seguro de que desea eliminar la <strong>post-tarea</strong>?",
    "Pos-Task has been clonned as a Pre-Task.":"Pre-tarea se ha clonado como post-tarea.",
    "Write the name of the task":"Escribe el nombre de la tarea",
    "Task metadata":"Metadatos de la tarea",
    "Author(s)":"Autor(es)",
    "Original authorship":"Autoría original",
    "Task language":"Idioma de la tarea",
    "Catalan":"Catalán",
    "English":"Inglés",
    "Spanish":"Español",
    "Russian":"Ruso",
    "Language in which the task is designed":"Idioma en el que está diseñada la tarea",
    "General aim of the task":"Objetivo general de la tarea",
    "Specific aim of the task":"Objetivo específico de la tarea",
    "Other (please specify)":"Otros (especifique)",
    "This information will be especially useful if you intend to share the task.":"Esta información será especialmente útil si planeas compartir la tarea.",
    "New Pre-Task":"Nueva pre-tarea",
    "Use a text for reading comprehension and to highlight language input":"Utilizar un texto para la comprensión lectora y para resaltar las aportaciones del idioma",
    "Text":"Texto",
    "Audios are great sources of input.":"Los audios son una gran fuente de información/input.",
    "Audio":"Audio",
    "Videos are excellent sources of ‘multimodal’ input. They present together images, text, and audio in meaningful ways that facilitate second language learning.":"Los vídeos son excelentes fuentes de input \"multimodal\". Presentan de forma integrada imágenes, texto y audio de manera significativa, lo que facilita el aprendizaje de una segunda lengua.",
    "Video":"Vídeo",
    "Reading comprehension dialogues provide an opportunity for both reading and speaking practice.":"Los diálogos de comprensión lectora ofrecen la oportunidad de practicar tanto la lectura como la expresión oral.",
    "Written dialogue":"Diálogo escrito",
    "Photos provide excellent opportunities to generate communication and interaction.":"Las fotos ofrecen excelentes oportunidades para generar comunicación e interacción.",
    "Photo":"Foto",
    "Video and audio transcripts provide exposure to rich and meaningful input that can be used in several ways.":"Las transcripciones de vídeo y audio proporcionan información rica y significativa que puede utilizarse de diversas maneras.",
    "Speech transcript":"Transcripción del discurso",
    "Interaction activities can be used in preparation for the main task.":"Las actividades de interacción pueden utilizarse como preparación para la tarea principal.",
    "Interaction activity":"Actividad de interacción",
    "Game":"Juego",
    "Warm-ups at the beginning of a lesson may serve as a smooth introduction to the topic/content of the lesson, as an opportunity for learners to progressively switch to the second or foreign language, and as a way to get into the language lesson mood.":"Los calentamientos al comienzo de una lección pueden servir como una introducción gradual al tema o contenido de la lección, como una oportunidad para que los alumnos hagan una transición progresiva hacia el uso de la segunda lengua o lengua extranjera, y como una forma de integrarse en el ambiente de la lección de idioma.",
    "Warm-up":"Calentamiento",
    "Main Task":"Tarea principal",
    "New Main Task":"Nueva tarea principal",
    "New Post-Task":"Nueva post-tarea",
    "Task repetition is known to have a positive impact on all aspects of production and learning.":"Se ha comprobado que la repetición de tareas tiene un impacto positivo en todos los aspectos de la producción y el aprendizaje.",
    "Task repetition":"Repetición de tareas/Repetición de la tarea",
    "Explicit explanations can help solve or consolidate language issues that came up during task performance.":"Las explicaciones explícitas pueden ayudar a resolver o consolidar los problemas de lenguaje que surgieron durante la realización de la tarea.",
    "Explicit explanation":"Explicación explícita",
    "Written to Oral / Oral to Written":"De escrito a oral / De oral a escrito",
    "Task model and exercises":"Modelo de tareas y ejercicios",
    "Exercises":"Ejercicios",
    "Shared task":"Tarea compartida",
    "The task <strong>":"La tarea <strong>",
    "</strong> is already shared with you.":"</strong> ya se ha compartido contigo",
    "Do you want to add the task <strong>'":"¿Deseas añadir la tarea <strong>'",
    "</strong> to the collection of tasks shared with you?":"</strong> a la colección de tareas compartidas con usted?",
    "If you accept this shared task, you will be allowed to clone it to create your own version of the task.":"Si aceptas esta tarea compartida, podrá clonarla para crear su propia versión de la tarea.",
    "Accept":"Aceptar",
    "Reject":"Rechazar",
    "Delete task":"Eliminar tarea",
    "You are about to delete the task <strong>":"Estás a punto de eliminar la tarea <strong>",
    "</strong>. This action cannot be undone.":"</strong>. Esta acción no se puede deshacer.",
    "(copy)":"(copia)",
    "- Select a proficiency level -":"- Selecciona un nivel de competencia -",
    "- Select a prompt -":"- Selecciona las intrucciones -",
    "- Select a role -":"- Selecciona los roles -",
    "- Select a session -":"- Selecciona la sesión -",
    "- Select a tag -":"- Selecciona una etiqueta -",
    "- Select an aim -":"- Selecciona un objetivo -",
    "- Select an organization -":"- Selecciona una institución -",
    "@":"@",
    "AI Tools and other resources":"Herramientas de IA y otros recursos",
    "Active":"Activo",
    "Add":"Añadir",
    "Add help item":"Añadir elemento de ayuda",
    "Add new FAQ":"Añadir nueva pregunta a FAQ",
    "Add new Task Example":"Añadir nueva tarea de ejemplo",
    "Add new Video":"Añadir nuevo vídeo",
    "Add new help":"Añadir nueva ayuda",
    "Add new organization":"Añadir nueva institución",
    "Add new prompt":"Anñadir una instrucción",
    "Add new role":"Añadir nuevo rol",
    "Add new student":"Añadir nuevo alumno",
    "Add selected tasks":"Añadir tareas seleccionadas",
    "Adjectives":"Adjetivos",
    "Administrator":"Administrador",
    "Adverbs":"Adverbios",
    "Agreeing/Disagreeing":"Estar de acuerdo/discrepar",
    "All adjectives":"Todos los adjetivos",
    "All adverbs":"Todos los adverbios",
    "All determiners":"Todos los determinantes",
    "All nouns":"Todos los sustantivos",
    "All pragmatic expressions":"Todas las expresiones pragmáticas",
    "All pronouns":"Todos los pronombres",
    "All user data and tasks will be deleted. This action cannot be undone.":"Se eliminarán todos los datos y tareas del usuario. Esta acción no se puede deshacer.",
    "All verbs":"Todos los verbos",
    "Analyze the text":"Analizar el texto",
    "Text analysis":"Análisis del texto",
    "Morphology":"Morfología",
    "Discourse markers":"Marcadores del discurso",
    "Semantics":"Semántica",
    "Classification":"Clasificación",
    "This analysis type is still under construction.":"Este tipo de análisis todavía está en construcción.",
    "There is no text to analyze.":"No hay texto para analizar.",
    "Classifying the text…":"Clasificando el texto…",
    "We couldn't classify this text. Please try again.":"No hemos podido clasificar este texto. Inténtalo de nuevo.",
    "Estimated CEFR level":"Nivel MCER estimado",
    "Confidence":"Confianza",
    "The text exceeded the model limit (~2048 tokens) and was truncated: the level reflects only the beginning of the text.":"El texto supera el límite del modelo (~2048 tokens) y se ha truncado: el nivel solo refleja el inicio del texto.",
    "Level distribution":"Distribución por niveles",
    "Analysis language": "Idioma de análisis",
    "The text will be analyzed in": "El texto será analizado en",
    "To change the analysis language, modify the task language in the task metadata section": "Para cambiar el idioma de análisis, modifica el idioma de la tarea en la sección de metadatos de la tarea",
    "Apologising":"Pedir disculpas",
    "Are you sure you want to delete?":"¿Estás seguro de que quieres borrar",
    "Are you sure you want to delete Help Item named?":"¿Está seguro de que desea eliminar el elemento de ayuda denominado?",
    "Are you sure you want to delete the group? This action cannot be undone.":"¿Está seguro de que desea eliminar el grupo? Esta acción no se puede deshacer.",
    "Are you sure you want to delete the post-task?":"¿Está seguro de que desea eliminar la postarea?",
    "Are you sure you want to delete the pre-task?":"¿Deseas eliminar la pretarea?",
    "Are you sure you want to delete the prompt? This action cannot be undone.":"¿Deseas eliminar la instrucción? Esta acción no se puede deshacer.",
    "Are you sure you want to delete the role? This action cannot be undone.":"¿Deseas eliminar el rol? Esta acción no se puede deshacer.",
    "Are you sure you want to delete the student? This action cannot be undone.":"¿Está seguro de que desea eliminar al alumno? Esta acción no se puede deshacer.",
    "Are you sure you want to delete this section? Tasks in this section will be moved to 'Unsectioned'.":"¿Está seguro de que desea eliminar esta sección? Las tareas de esta sección se moverán a 'No seccionadas'.",
    "Are you sure you want to delete this tag? This action cannot be undone.":"¿Está seguro de que desea eliminar esta etiqueta? Esta acción no se puede deshacer.",
    "Are you sure you want to proceed?":"¿Deseas continuar?",
    "Assignments for the role:":"Instrucciones para el rol:",
    "Beginnings are always difficult":"Los comienzos siempre son difíciles",
    "Belongs to groups":"Pertenece a un grupo",
    "Body":"Cuerpo",
    "By clicking this box, I state that I have read and understood the ":"Al hacer clic en esta casilla, declaro que he leído y comprendido los ",
    "Change color":"Cambiar color",
    "Check out some of the questions teachers/designers have asked us so far. The answers will help you to get the most of the tool":"Echa un vistazo a algunas de las preguntas que los profesores/diseñadores nos han hecho hasta ahora. Las respuestas te ayudarán a sacar el máximo partido de la herramienta",
    "Click on the plus icon of each user you want to select:":"Haz clic en el icono 'más' de cada usuario que desees seleccionar:",
    "Clone":"Clonar",
    "Clone as Pos-task":"Clonar como postarea",
    "Clone as Pre-task":"Clonar como pretarea",
    "Clone prompt":"Instrucción de clonación",
    "Clone task":"Clonar tarea",
    "Comparative adjectives":"Adjetivos comparativos",
    "Comparative adverbs":"Adverbios comparativos",
    "Contact us":"Ponte en contacto con nosotros",
    "Contractions":"Contracciones",
    "Coordinating Conjunctions":"Conjunciones",
    "Create":"Crear",
    "Create Section":"Crear sección",
    "Create a new section":"Crear una nueva sección",
    "Create a new task":"Crear una nueva tarea",
    "DD/MM/YYYY":"DD/MM/AAAA",
    "DD/MM/YYYY hh:mm":"DD/MM/YYYY hh:mm",
    "Dashboard":"Panel inicial",
    "Date":"Fecha",
    "Delete FAQ":"Borrar FAQ",
    "Delete Task Example":"Ejemplo de eliminación de una tarea",
    "Delete Video":"Borrar vídeo",
    "Delete feedback":"Eliminar comentarios",
    "Delete help":"Borrar ayuda",
    "Delete organization":"Borrar institución",
    "Delete prompt":"Borrar instrucción",
    "Delete section":"Suprimir sección",
    "Delete student":"Borrar estudiante",
    "Delete task example":"Ejemplo de tarea de supresión",
    "Delete user":"Borrar usuario",
    "Determiner":"Determinante",
    "Determiners":"Determinantes",
    "Discard":"Descartar",
    "Do not hesitate to contact us with any questions you may have.":"No dude en ponerse en contacto con nosotros si tiene alguna pregunta.",
    "Do you want to add the task":"¿Desea añadir la tarea",
    "Download DOCX":"Descargar DOCX",
    "Downloading...":"Descargando...",
    "Drag and Drop files here":"Arrastra y suelta los archivos aquí",
    "Edit FAQ":"Editar FAQ",
    "Edit Help Item":"Editar elemento de ayuda",
    "Edit Main Task":"Editar tarea principal",
    "Edit Organization":"Editar institución",
    "Edit Post-Task: Audio":"Editar postarea: Audio",
    "Edit Post-Task: Game":"Editar postarea: Juego",
    "Edit Post-Task: Interaction Activity":"Editar postarea: Actividad de interacción",
    "Edit Post-Task: Photo":"Editar postarea: Foto",
    "Edit Post-Task: Repetition":"Editar postarea: Repetición",
    "Edit Post-Task: Task model and exercises":"Editar postarea: Modelo de tarea y ejercicios",
    "Edit Post-Task: Teacher Feedback":"Editar postarea: Comentarios del docente",
    "Edit Post-Task: Text":"Editar postarea: Texto",
    "Edit Post-Task: Video":"Editar postarea: Vídeo",
    "Edit Post-Task: Written Dialogue":"Editar postarea: Diálogo escrito",
    "Edit Post-Task: Written to Oral / Oral to Written":"Editar postarea: De escrito a oral / De oral a escrito",
    "Edit Pre-Task: Audio":"Editar pretarea: Audio",
    "Edit Pre-Task: Game":"Editar pretarea: Juego",
    "Edit Pre-Task: Interaction activity":"Editar pretarea: Actividad de interacción",
    "Edit Pre-Task: Photo":"Editar pretarea: Foto",
    "Edit Pre-Task: Speech transcript":"Editar pretarea: Transcripción de un diálogo",
    "Edit Pre-Task: Text":"Editar pretarea: Texto",
    "Edit Pre-Task: Video":"Pretarea de edición: Vídeo",
    "Edit Pre-Task: Warm-up":"Edit Pretarea: Calentamiento",
    "Edit Pre-Task: Written Dialogue":"Pretarea de edición: Diálogo escrito",
    "Edit Section":"Editar Sección",
    "Edit Video":"Editar vídeo",
    "Edit help":"Editar ayuda",
    "Edit name":"Editar nombre",
    "Edit organizataion":"Editar institución",
    "Edit prompt":"Editar instrucción",
    "Edit section":"Editar sección",
    "Edit student":"Editar estudiante",
    "Edit task":"Editar tarea",
    "Edit user":"Editar usuario",
    "Email address":"Dirección de correo electrónico",
    "Enter a descriptive name":"Introduzca un nombre descriptivo",
    "Enter a title":"Introduzca un título",
    "Enter a weigh":"Introduzca un peso",
    "Enter section name":"Introduzca el nombre de la sección",
    "Enter the position of this help content relative to other help contents. The higher the value the lower it will be sorted.":"Introduzca la posición de este contenido de ayuda en relación con otros contenidos de ayuda. Cuanto mayor sea el valor, más abajo se ordenará.",
    "Enter the title":"Introduzca el título",
    "Examples":"Ejemplos",
    "FAQs":"Preguntas frecuentes",
    "Feedback":"Comentarios",
    "Feedback management":"Gestión de la información",
    "Feedbacks":"Comentarios",
    "Future Perfect":"Futuro Perfecto",
    "Future Perfect Continuous":"Futuro Perfecto Progresivo",
    "Future Perfect Passive":"Futuro Perfecto pasivo",
    "Future Simple":"Futuro simple",
    "Future Simple Passive":"Futuro simple pasivo",
    "Future ‘going to’":"Futuro 'going to'",
    "Generate password":"Generar contraseña",
    "Giving an opinion":"Dar una opinión",
    "Go back":"Volver atrás",
    "Greeting":"Saludos",
    "Group":"Grupo",
    "Groups":"Grupos",
    "Help":"Ayuda",
    "Help index":"Índice de ayuda",
    "Help item":"Ayuda",
    "Help items":"Ayuda",
    "Help management":"Ayuda a la gestión",
    "How do you typically teach?":"¿Cómo sueles enseñar?",
    "If you accept, you will find this task in the 'Shared with me' section. From there you will be able to clone it and create your own version of the task.":"Si aceptas, encontrarás esta tarea en la sección 'Compartida conmigo'. Desde allí podrás clonarla y crear tu propia versión de la tarea.",
    "If you are in primary or secondary, here's a list of AI tools you can use to assist your teaching. Signing up and using the tools is free.<br /> You can bring the outcomes of those tools and cut and paste them into the taskGen textbox.":"Si trabajas en primaria o secundaria, aquí tienes una lista de herramientas de IA que puedes utilizar para ayudarte en tu labor docente. Registrarse y utilizar las herramientas es gratuito.<br /> Puedes traer los resultados de esas herramientas y cortarlos y pegarlos en el cuadro de texto de taskGen.",
    "Imperative":"Imperativo",
    "Important":"Importante",
    "In this project we are developing and piloting a tool that will help teachers and task and syllabus designers with organizing and automating the design of second/foreign language communicative tasks. If you wish to know more about the project, please click here...":"En este proyecto estamos desarrollando y poniendo a prueba una herramienta que ayudará a profesores y diseñadores de tareas y programas de estudio a organizar y automatizar el diseño de tareas comunicativas en segundas lenguas o lenguas extranjeras. Si desea saber más sobre el proyecto, haga clic aquí...",
    "Interface language":"Lenguaje de interfaz",
    "Irregular plurals":"Plurales irregulares",
    "Irregular verbs":"Verbos irregulares",
    "Issue":"Edición",
    "It is an ongoing three-year research project made possible by a grant PID2023-149648NB-I00 funded by the Ministry of Science and Innovation (MCIN) and National Research Agency (AEI) 10.13039/501100011033.":"Se trata de un proyecto de investigación en curso de tres años de duración que ha sido posible gracias a una subvención PID2020-119009RB-I00 financiada por el Ministerio de Ciencia e Innovación (MCIN) y la Agencia Estatal de Investigación (AEI) 10.13039/501100011033.",
    "Language":"Idioma",
    "Lastname":"Apellido",
    "Log in using your email":"Inicia sesión con tu correo electrónico",
    "Log out":"Cerrar sesión",
    "Login or register":"Iniciar sesión o registrarse",
    "Mail":"Correo",
    "Modal Verbs":"Verbos modales",
    "Modify":"Modificar",
    "More link":"Más enlaces",
    "Move down":"Baja",
    "Move up":"Sube",
    "My task designs":"Mis diseños de tareas",
    "New FAQ":"Nuevas FAQ",
    "New Post-Task: Audio":"Nueva tarea posterior: Audio",
    "New Post-Task: Exercises":"Nueva tarea posterior: Ejercicios",
    "New Post-Task: Explicit Explanation":"Nueva tarea posterior: Explicación explícita",
    "New Post-Task: Game":"Nueva tarea posterior: Juego",
    "New Post-Task: Interaction Activity":"Nueva tarea posterior: Actividad de interacción",
    "New Post-Task: Photo":"Nueva tarea posterior: Foto",
    "New Post-Task: Repetition":"Nueva tarea posterior: Repetición",
    "New Post-Task: Task model and exercises":"Nueva post-tarea: Modelo de tarea y ejercicios",
    "New Post-Task: Teacher Feedback":"Nueva tarea posterior: Comentarios del profesor",
    "New Post-Task: Text":"Nueva tarea posterior: Texto",
    "New Post-Task: Video":"Nueva tarea posterior: Vídeo",
    "New Post-Task: Written Dialogue":"Nueva tarea posterior: Diálogo escrito",
    "New Post-Task: Written to Oral / Oral to Written":"Nueva tarea posterior: De escrito a oral / De oral a escrito",
    "New Pre-Task: Audio":"Nueva pretarea: Audio",
    "New Pre-Task: Game":"Nueva pretarea: Juego",
    "New Pre-Task: Interaction activity":"Nueva pretarea: Actividad de interacción",
    "New Pre-Task: Photo":"Nueva pretarea: Foto",
    "New Pre-Task: Speech transcript":"Nueva pretarea: Transcripción de discursos",
    "New Pre-Task: Text":"Nueva pretarea: Texto",
    "New Pre-Task: Video":"Nueva pretarea: Vídeo",
    "New Pre-Task: Warm-up":"Nueva pretarea: Calentamiento",
    "New Pre-Task: Written Dialogue":"Nueva pretarea: Diálogo escrito",
    "New Task Example":"Ejemplo de nueva tarea",
    "New Video":"Nuevo vídeo",
    "New help":"Nueva ayuda",
    "New organization":"Nueva institución",
    "New user":"Nuevo usuario",
    "No FAQ selected.":"No se ha seleccionado ninguna FAQ.",
    "No Video selected.":"No hay vídeo seleccionado.",
    "No help selected.":"No se ha seleccionado ninguna ayuda.",
    "No prompt assigned":"Sin indicación asignada",
    "No role assigned":"Sin función asignada",
    "No task example selected.":"No se ha seleccionado ningún ejemplo de tarea.",
    "No tasks in this section":"No hay tareas en esta sección",
    "No text specified for this pre-task":"No se ha especificado ningún texto para esta pretarea",
    "No user selected.":"Ningún usuario seleccionado.",
    "Not translated":"No traducido",
    "Nouns":"Sustantivos",
    "Number of students":"Número de estudiantes",
    "Only MP4 videos are allowed.":"Sólo se admiten vídeos MP4.",
    "Organization":"Institución",
    "Organizations":"Instituciones",
    "Organizations management":"Gestión de instituciones",
    "Passive":"Pasiva",
    "Password":"Contraseña",
    "Past Continuous":"Pretérito imperfecto progresivo",
    "Past Continuous Passive":"Pasado continuo pasivo",
    "Past Perfect":"Pretérito plucuamperfecto",
    "Past Perfect Continuous":"Pretérito pluscuamperfecto progresivo ",
    "Past Perfect Continuous Passive":"Pretérito pluscuamperfecto progresivo en pasiva",
    "Past Perfect Passive":"Pretérito pluscuamperfecto en pasiva",
    "Past Simple":"Pasado Simple",
    "Past Simple Passive":"Pasado simple pasivo",
    "Phrasal verbs":"Verbos preposicionales",
    "Pos-task":"Postarea",
    "Possessive Pronouns":"Pronombres posesivos",
    "Possessive wh-pronoun":"Pronombre posesivo",
    "Pragmatic Expressions":"Expresiones pragmáticas",
    "Pre-Task has been clonned as a Pos-Task.":"La pretarea ha sido colanda como postarea.",
    "Pre-task":"Pretarea",
    "Prepositions":"Preposiciones",
    "Present Continuous Passive":"Presente continuo en pasiva",
    "Present Perfect":"Pretérito perfecto",
    "Present Perfect Continuous":"Pretérito perfecto progresivo",
    "Present Perfect Continuous Passive":"Pretérito perfecto progresivo en pasiva",
    "Present Perfect Passive":"Pretérito perfecto en pasiva",
    "Present Simple":"Presente de indicativo en pasiva",
    "Present Simple Passive":"Presente de indicativo en pasiva",
    "Previously formatted text":"Texto formateado previamente",
    "Print":"Imprimir",
    "Prompt":"Prompt",
    "Prompts":"Prompts",
    "Pronouns":"Pronombres",
    "Quizbot will let you <strong>transform an audio file into text</strong> and then <strong>generate questions</strong>.<br /> You can copy and paste the question into the taskGen text box. You can also insert the link in taskGen or upload the audio files you create with these apps.":"Quizbot te permitirá <strong>transformar un archivo de audio en texto</strong> y luego <strong>generar preguntas</strong>.<br /> Puedes copiar y pegar la pregunta en el cuadro de texto de taskGen. También puedes insertar el enlace en taskGen o subir los archivos de audio que crees con estas apps.",
    "Quizlet is a tool that allows students to learn vocabulary by means of customised flashcards":"Quizlet es una herramienta que permite a los estudiantes aprender vocabulario mediante fichas personalizadas",
    "Read more":"Seguir leyendo",
    "References":"Referencias",
    "Requesting":"Solicitar",
    "Resource":"Recursos",
    "Role":"Rol",
    "Roles":"Roles",
    "Russian analyzer not available yet":"Analizador en ruso no disponible todavía",
    "The Russian text analyzer is not available yet, but it will be soon. We are working on it!":"El analizador de texto en ruso no está disponible todavía, pero lo estará pronto. ¡Estamos trabajando en ello!",
    "Section":"Sección",
    "Section Name":"Nombre de la sección",
    "See some examples":"Vea algunos ejemplos",
    "Select the groups this role is assigned to":"Seleccione los grupos a los que está asignada esta función",
    "Select the tasks you want to add as examples:":"Seleccione las tareas que desea añadir como ejemplos:",
    "Shared directly with me":"Compartido directamente conmigo",
    "Shared with me":"Compartido conmigo",
    "Showing interest":"Mostrar interés",
    "Sorry! The result of the text analysis is either empty or some errors were found. Revise and change your text and try it again.":"Lo sentimos El resultado del análisis de texto está vacío o se han encontrado algunos errores. Revisa y cambia tu texto e inténtalo de nuevo.",
    "Student":"Estudiante",
    "Students":"Estudiantes",
    "Subordinating conjunctions":"Conjunciones subordinantes",
    "Suggesting":"Sugerir",
    "Superlative adjectives":"Adjetivos superlativos",
    "Superlative adverbs":"Adverbios superlativos",
    "Tags":"Etiquetas",
    "Task":"Tarea",
    "Task examples":"Ejemplos de tareas",
    "Teacher":"Profesor",
    "Teacher notes":"Notas del profesor",
    "Teachers":"Profesores",
    "Teaser":"Teaser",
    "Text analyzed in":"Texto analizado en",
    "Text for the more link":"Texto del enlace 'más'",
    "Thanking":"Agradecimientos",
    "Thanks for your feedback.":"Gracias por tus comentarios.",
    "The program can <strong>generate videos</strong> on the basis of the topic you choose. You have limited access as a free user.<br /> You can also insert the link in taskGen or upload the audio files you create with these apps.":"El programa puede <strong>generar vídeos</strong> en función del tema que elijas. Como usuario gratuito tienes acceso limitado.<br /> También puedes insertar el enlace en taskGen o subir los archivos de audio que crees con estas apps.",
    "The task":"La tarea",
    "The tool is still under construction, but give it a try! We\'re working on it.":"La herramienta aún está en construcción, pero ¡pruébala! Estamos trabajando en ello.",
    "There are no groups":"No hay grupos",
    "There are no help items defined. Add your first help item.":"No hay elementos de ayuda definidos. Añade tu primer elemento de ayuda.",
    "There are no post-tasks defined":"No hay postareas definidas",
    "There are no prompts":"No hay indicaciones",
    "There are no prompts defined":"No hay avisos definidos",
    "There are no roles":"No hay funciones",
    "There are no tasks defined":"No hay tareas definidas",
    "There was a problem uploading files. You can upload a maximum of 5 files simultaneously and not more than 50MB. Try reducing file sizes or uploading fewer files simultaneously. If the problem persists, contact us.":"Ha habido un problema al subir archivos. Puedes subir un máximo de 5 archivos simultáneamente y no más de 50MB. Intenta reducir el tamaño de los archivos o subir menos archivos simultáneamente. Si el problema persiste, póngase en contacto con nosotros.",
    "This action cannot be undone.":"Esta acción no puede deshacerse.",
    "This post-task has no text":"Esta postarea no tiene texto",
    "This prompt has no text":"Este mensaje no tiene texto",
    "This tag already exists.":"Esta etiqueta ya existe.",
    "Title of the Post-Task":"Título de la postarea",
    "Title of the Pre-Task":"Título de la pretarea",
    "Title of the Prompt":"Título de la pregunta",
    "To use this link, you must have a TaskGen account. Go to the login page and access with your account or register.":"Para utilizar este enlace, debes tener una cuenta taskGen. Ves a la página de inicio de sesión y accede con tu cuenta o regístrate.",
    "Translations":"Traducciones",
    "Two classic web sites where you can <strong>find movie scripts</strong> and scripts from <strong>TV series</strong>.":"Dos webs clásicas donde <strong>encontrar guiones de cine</strong> y guiones de <strong>series de televisión</strong>.",
    "Unsectioned":"Sin secciones",
    "Use this tool to <strong>generate a dialogue</strong>. Just describe your objective and a bit of a context, and it’ll give you a perfectly crafted dialogue for you.":"Utiliza esta herramienta para <strong>generar un diálogo</strong>. Sólo tienes que describir tu objetivo y un poco de contexto, y te dará un diálogo perfectamente elaborado para ti.",
    "Use this tool to <strong>generate a dialogue</strong>. Just describe your objective and a bit of a context, and it'll give you a perfectly crafted dialogue for you.<br /> You can copy and paste the dialogues into the taskGen text box. Then you can use the function \"Analyze\" to get a complete analysis of the linguistic features of the text. You can automatically highlight and or change font size to bring attention to those features (input enhancement)":"Utiliza esta herramienta para <strong>generar un diálogo</strong>. Sólo tienes que describir tu objetivo y un poco de contexto, y te dará un diálogo perfectamente elaborado para ti.<br /> Puedes copiar y pegar los diálogos en el cuadro de texto taskGen. Después puedes utilizar la función 'Analizar' para obtener un análisis completo de las características lingüísticas del texto. Puede resaltar automáticamente y/o cambiar el tamaño de la fuente para llamar la atención sobre esas características (mejora de la entrada)",
    "User":"Usuario",
    "User groups":"Grupos de usuarios",
    "User or password are not valid":"El usuario o la contraseña no son válidos",
    "Users Groups":"Grupos de usuarios",
    "Users management":"Gestión de usuarios",
    "Users selected:":"Usuarios seleccionados:",
    "Verb Tense":"Tiempo verbal",
    "Verbs":"Verbos",
    "Video management":"Gestión de vídeo",
    "Video tutorials":"Tutoriales en vídeo",
    "We are sorry! There was a processing error. Text Analysis is out of order at this moment. Give us some time to recover and try again later.":"Lo sentimos Se ha producido un error de procesamiento. Análisis de Texto está fuera de servicio en este momento. Denos algo de tiempo para recuperarnos y vuelva a intentarlo más tarde.",
    "We are working to improve the Taskgen site.":"Estamos trabajando para mejorar el sitio de taskGen.",
    "Weight":"Peso",
    "Wh-Determiner":"Determinante con Wh-",
    "Wh-adverb":"Adverbio con Wh-",
    "Wh-pronouns":"Pronombres con Wh- ",
    "What is <span>taskGen</span>?":"¿Qué es <span>taskGen</span>?",
    "What's your general teaching framework?":"¿Cuál es tu marco general de enseñanza?",
    "Where do you usually teach?":"¿Dónde sueles dar clases?",
    "Wish to design a task?":"¿Deseas diseñar una tarea?",
    "Word Categories":"Categorías de palabras",
    "Write a tag name":"Escribe un nombre de etiqueta",
    "Write the lastname of the user":"Escribe el apellido del usuario",
    "Write the name of the user":"Escribe el nombre del usuario",
    "Write your mail address and we\\'ll send you an email with instructions to finish your registration.":"Escribe tu dirección de correo y te enviaremos un e-mail con las instrucciones para finalizar tu inscripción.",
    "YYYY-MM-DD":"AAAA-MM-DD",
    "YYYY-MM-DD hh:mm:ss":"AAAA-MM-DD hh:mm:ss",
    "YYYYMMDD":"AAAAMMDD",
    "You are about to delete FAQ content":"Estás a punto de eliminar el contenido de las FAQ",
    "You are about to delete Video content":"Estás a punto de borrar el contenido del vídeo",
    "You are about to delete feedback content":"Estás a punto de eliminar el contenido de los comentarios",
    "You are about to delete help content":"Estás a punto de borrar contenido de ayuda",
    "You are about to delete organization content":"Estás a punto de eliminar el contenido de la institución",
    "You are about to delete the task":"Estás a punto de eliminar la tarea",
    "You are about to delete the task example":"Estás a punto de borrar el ejemplo de tarea",
    "You are about to delete user with email":"Estás a punto de eliminar un usuario con correo electrónico",
    "You are not allowed to access this section.":"No tienes autorización para acceder a esta sección.",
    "You can <strong>generate new pictures</strong>.":"Puedes <strong>generar nuevas imágenes</strong>.",
    "You can <strong>get ideas</strong> and example about interaction activities in the International Task Bank.":"Puedes <strong>obtener ideas</strong> y ejemplos sobre actividades de interacción en el Banco Internacional de Tareas.",
    "You can add users of your organization or any user in taskGen.":"Puedes añadir usuarios de su organización o cualquier usuario en taskGen.",
    "You can get some inspiration about possible pre-tasks in the International Task Bank where you can obtain and download full task designs.":"Puedes inspirarse sobre posibles tareas previas en el Banco Internacional de Tareas, donde podrá obtener y descargar diseños completos de tareas.",
    "You can insert a text and have the program <strong>read the text for you</strong>. You have limited access as a free user.":"Puedes insertar un texto y hacer que el programa <strong>lo lea por ti</strong>. Tienes acceso limitado como usuario gratuito.",
    "You can insert a text and have the program <strong>read the text for you</strong>. You have limited access as a free user. You can copy the link in the taskGen text box or upload the audio file onto to your speech transcript pre-task.":"Puedes insertar un texto y hacer que el programa <strong>lo lea por ti</strong>. Como usuario gratuito tienes acceso limitado. Puede copiar el enlace en el cuadro de texto de taskGen o cargar el archivo de audio en su pretarea de transcripción de voz.",
    "You can upload a picture and the program will <strong>generate questions</strong> about the picture automatically.":"Puedes subir una foto y el programa <strong>generará preguntas</strong> sobre la foto automáticamente.",
    "You can use this tool to <strong>have a text be read</strong> by a computerized voice.":"Puedes utilizar esta herramienta para <strong>que un texto sea leído</strong> por una voz computerizada.",
    "You must generate a password for the user. Use the button below.":"Debes generar una contraseña para el usuario. Utiliza el botón de abajo.",
    "You must generate or write a password for the user. Use the button below.":"Debes generar o escribir una contraseña para el usuario. Utiliza el botón de abajo.",
    "You must give the user a role.":"Debes asignar un rol al usuario",
    "[video ":"[vídeo ",
    "[video=":"[video=",
    "a":"a",
    "edpuzzle will let you <strong>create interactive videos</strong> where questions appear as they watch the video. You can include the link to the edpuzzle video in the taskGen text box.":"edpuzzle le permitirá <strong>crear vídeos interactivos</strong> en los que aparecerán preguntas mientras ven el vídeo. Puede incluir el enlace al vídeo edpuzzle en el cuadro de texto taskGen.",
    "hour":"hora",
    "hours":"horas",
    "is already shared with you.":"ya se comparte con usted.",
    "minute":"minuto",
    "minutes":"minutos",
    "not used":"no utilizado",
    "or get some inspiration":"o inspírate",
    "processing":"procesamiento",
    "read more...":"leer más...",
    "second":"segundo",
    "seconds":"segundos",
    "students":"estudiantes",
    "to the collection of tasks shared with you?":"a la colección de tareas compartidas con usted?",
    "used by":"utilizado por",
    "Search":"Buscar",
    "Search in all fields...":"Buscar en todos los campos...",
    "Searching...":"Buscando...",
    "Sort by":"Ordenar por",
    "Clear filters":"Limpiar filtros",
    "Total results":"Resultados totales",
    "Searching for":"Buscando",
    "Filters":"Filtros",
    "Rows per page":"Filas por página",
    "of":"de",
    "Clear":"Limpiar",
    "Search by email, username, name, organization...":"Buscar por email, usuario, nombre, organización...",
    "Search by organization name...":"Buscar por nombre de organización...",
    "New version available":"Nueva versión disponible",
    "Version":"Versión",
    "is available. Reload to update.":"está disponible. Recarga para actualizar.",
    "Reload":"Recargar",
    "Later":"Más tarde",
    "Translate with DeepL":"Traducir con DeepL",
    "Translating...":"Traduciendo...",
    "Please enter text to translate":"Por favor, introduce el texto a traducir",
    "Cannot translate to English (source language)":"No se puede traducir al inglés (idioma de origen)",
    "Please enter English title first":"Por favor, introduce primero el título en inglés",
    "Please enter English body first":"Por favor, introduce primero el cuerpo en inglés",
    "Translation error: ":"Error de traducción: ",
    "You can add translations to other languages after creating the FAQ.":"Puedes añadir traducciones a otros idiomas después de crear la FAQ.",
    "DeepL does not support Catalan":"DeepL no soporta catalán",
    "Please enter English teaser first":"Por favor, introduce primero el teaser en inglés",
    "Please enter English examples first":"Por favor, introduce primero los ejemplos en inglés",
    "Please enter English references first":"Por favor, introduce primero las referencias en inglés",
    "Export User Events":"Exportar Eventos de Usuario",
    "Export Users":"Exportar Usuarios",
    "Export Tasks":"Exportar Tareas",
    "Export Tasks Groups":"Exportar Grupos de Tareas",
    "Export NLP Events":"Exportar Eventos NLP",
    "Action":"Acción",
    "Reference":"Referencia",
    "Start":"Inicio",
    "End":"Fin",
    "Start date":"Fecha de inicio",
    "End date":"Fecha de finalización",
    "Duration":"Duración",
    "Teaching location":"Lugar de enseñanza",
    "Teaching model":"Modelo de enseñanza",
    "Teaching framework":"Enfoque de eseñanza",
    "Teaching years":"Años de experiencia docente",
    "User ID":"ID de Usuario",
    "Number of pre-tasks":"Número de pretareas",
    "Number of subtasks":"Número de subtareas",
    "Number of post-tasks":"Número de postareas",
    "Number of sessions":"Número de sesiones",
    "Cloned":"Clonada",
    "Original source":"Fuente original",
    "Original task":"Tarea original",
    "Task name":"Nombre de tarea",
    "Subtask name":"Nombre de subtarea",
    "Number of members":"Número de miembros",
    "Add new Feedback":"Añadir nuevo feedback",
    "Select the functionality of the application about which you want to comment":"Selecciona la funcionalidad de la aplicación sobre la que deseas comentar",
    "Subject":"Asunto",
    "Write the subject of your comment":"Escribe el asunto de tu comentario",
    "Comment":"Comentario",
    "Leave your comments here":"Deja tus comentarios aquí",
    "ID":"ID",
    "Country":"País",
    "Region":"Región",
    "Level":"Nivel",
    "Proficiency level":"Nivel de competencia",
    "Option":"Opción",
    "Your session has expired. Please log in again.":"Tu sesión ha expirado. Por favor, inicia sesión de nuevo.",
    "You do not have permission to perform this action.":"No tienes permiso para realizar esta acción.",
    "The requested resource was not found.":"El recurso solicitado no fue encontrado.",
    "Server error. Please try again later.":"Error del servidor. Por favor, inténtalo de nuevo más tarde.",
    "An error occurred. Please try again.":"Ha ocurrido un error. Por favor, inténtalo de nuevo.",
    "Network error. Please check your connection.":"Error de red. Por favor, comprueba tu conexión.",
    "Can view":"Puede ver",
    "Can edit":"Puede editar",
    "All can view":"Todos pueden ver",
    "All can edit":"Todos pueden editar",
    "Default":"Por defecto",
    "Show members":"Mostrar miembros",
    "Hide members":"Ocultar miembros",
    "Group members":"Miembros del grupo",
    "You can edit this task":"Puedes editar esta tarea",
    "Permission":"Permiso",
    "members with access":"miembros con acceso",
    "Select members and their permissions:":"Selecciona los miembros y sus permisos:",
    "Clear all":"Borrar todos",
    "Loading members...":"Cargando miembros...",
    "Search by email or name...":"Buscar por email o nombre...",
    "members":"miembros",
    "Group members and their permissions:":"Miembros del grupo y sus permisos:",
    "To change member permissions, edit the group in the Groups section.":"Para cambiar los permisos de los miembros, edita el grupo en la sección de Grupos.",
    "You can share the task <strong>{{taskName}}</strong> with other people.":"Puedes compartir la tarea <strong>{{taskName}}</strong> con otras personas.",
    "Add members to the group and set their permissions. These permissions will apply when sharing tasks with this group.":"Añade miembros al grupo y establece sus permisos. Estos permisos se aplicarán cuando compartas tareas con este grupo.",
    "Click to add members:":"Haz clic para añadir miembros:",
    "Group members:":"Miembros del grupo:",
    "All Tasks":"Todas las tareas",
    "New subfolder":"Nueva subcarpeta",
    "New folder":"Nueva carpeta",
    "New task":"Nueva tarea",
    "- Tag -":"- Etiqueta -",
    "- Level -":"- Nivel -",
    "- Aim -":"- Objetivo -",
    "Icon view":"Vista de iconos",
    "List view":"Vista de lista",
    "Create folder":"Crear carpeta",
    "New Folder":"Nueva carpeta",
    "Create task":"Crear tarea",
    "New Task":"Nueva tarea",
    "This folder is empty":"Esta carpeta está vacía",
    "Create a new task or folder, or drag items here":"Crea una nueva tarea o carpeta, o arrastra elementos aquí",
    "No tasks match the filters":"Ninguna tarea coincide con los filtros",
    "Try adjusting or clearing the filters":"Intenta ajustar o limpiar los filtros",
    "Open":"Abrir",
    "No members in this group":"No hay miembros en este grupo",
    "Remove from group":"Eliminar del grupo",
    "New password":"Nueva contraseña",
    "Confirm password":"Confirmar contraseña",
    "Passwords do not match":"Las contraseñas no coinciden",
    "Password updated successfully.":"La contraseña se ha actualizado correctamente.",
    "This reset link is invalid or has expired.":"Este enlace de restablecimiento no es válido o ha caducado.",
    "Back to login":"Volver al inicio de sesión",
    "Update password":"Actualizar contraseña",
    "We've sent you an email with a link to reset your password.":"Te hemos enviado un correo electrónico con un enlace para restablecer tu contraseña."
}
